import { useQuery } from "@tanstack/react-query";
import { przezmorzeApi } from "../../api/api";
import type { Dayjs } from "dayjs";

export interface IncomingTransfer {
  id: string;
  date: string; // ISO string
  processingResult: {
    status: string;
    orderId?: {
      id: string;
      userFriendlyId: number;
    };
    reason?: string;
  };
  account: string;
  tx: {
    header: {
      currency: string;
    };
    transaction?: {
      balance: string;
      payer: string;
      details: string;
    };
  };
}

interface UseIncomingTransfersOptions {
  startDate: Dayjs;
}

export function useIncomingTransfers({ startDate }: UseIncomingTransfersOptions) {
  return useQuery<IncomingTransfer[]>({
    queryKey: ["incomingTransfers", startDate.format("YYYY-MM-DD")],
    staleTime: 0,
    queryFn: async () => {
      const response = await przezmorzeApi.get<IncomingTransfer[]>(`/bank-connect/`, {
        params: {
          startDate: startDate.format("YYYY-MM-DD"),
        },
      });
      return response.data;
    },
  });
}
